module.exports = "/static/assets/709e9ca35bae81964ab0b585a235fc25.png";